import React from "react";
import { Helmet } from "react-helmet";

import Page from "../../components/layout/Page";

//@ts-ignore
import showroomBg from "../../assets/images/showroom-hero.jpg";
//@ts-ignore
import cat1 from "../../assets/images/automatizari.jpg";
//@ts-ignore
import img7 from "../../assets/images/pages/7.jpg";
//@ts-ignore
import headerImage from "../../assets/images/headers/h-5.jpg";

export default function Automatizari() {
  return (
    <Page>
      {
        //@ts-ignore
        <Helmet>
          <title>
            Distribuitor Siemens Automatizări Industriale | Asempera
          </title>
          <meta
            name="description"
            content={`Asempera, distribuitor oficial Siemens cu peste 20 de ani experiență. Vă oferim gama completă de echipamente pentru automatizări: PLC SIMATIC, HMI, SINAMICS. Suport tehnic și stocuri disponibile.`}
          />
        </Helmet>
      }
      <div
        className="page-title with-background"
        style={{ backgroundImage: `url(${headerImage})` }}
      >
        <div className="shade"></div>
        <h1>Automatizări industriale</h1>
      </div>
      <div className="an-section">
        <div className="an-content">
          <p>
            Cu o <strong>experiență de peste 20 de ani în domeniu</strong>,
            suntem partenerul de încredere pentru soluții de automatizări
            industriale. Misiunea noastră este să optimizăm procesele tale,
            crescând eficiența, fiabilitatea și productivitatea prin tehnologie
            de ultimă generație.
            <br></br>
            <br></br>
            Ca <strong>distribuitor oficial Siemens</strong>, garantăm
            implementarea unor soluții inovatoare și de cea mai înaltă calitate,
            pregătite pentru provocările viitorului.
          </p>
        </div>
      </div>
      <div className="an-section bg-1">
        <div className="an-content flex align-center">
          <div className="an-col w-7">
            <h4 className="strong">De ce să alegeți Asempera?</h4>
            <p className="mb-0">
              Vă oferim <strong>mai mult decât echipamente</strong>, vă oferim
              soluții complete, gândite pentru succesul afacerii dumneavoastră.
            </p>
            <p className="mb-0">
              <strong>Peste 20 de ani experiență:</strong> Cunoaștem în detaliu
              piața și produsele. Experiența noastră în distribuția de
              echipamente industriale vă asigură că veți primi recomandări
              corecte și soluții adaptate nevoilor tehnice.
            </p>
            <p className="mb-0">
              <strong>Distribuitor oficial Siemens:</strong> Aveţi garanţia unor
              produse 100% originale, acces la întregul portofoliu Siemens şi
              preţuri competitive. Evitaţi riscurile şi lucraţi cu un partener
              autorizat
            </p>
            <p className="mb-0">
              <strong>Suport tehnic specializat:</strong> Echipa noastră vă stă
              la dispoziție pentru a vă ajuta să identificați produsele
              potrivite pentru proiectul dumneavoastră. Oferim consultanță
              tehnică pentru a face cea mai bună alegere.
            </p>
            <p className="">
              Pentru mai multe detalii contactați-ne la{" "}
              <strong>info@asempera.ro</strong> sau accesați{" "}
              <strong>www.elconet.ro</strong>
            </p>
          </div>
          <div className="an-col w-5">
            <img src={img7} className="max-400 center"></img>
          </div>
        </div>
      </div>
    </Page>
  );
}
